"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../types/tape-builder-base");
exports.artifactType = 'fundingRequest';
// Zod schema and new config type
exports.NodeConfigSchema = zod_1.z
    .object({
    tapeDescription: zod_1.z
        .string()
        .describe('Description for funding request tape'),
    lenderVerificationConfig: tape_builder_base_1.LenderVerificationConfigSchema.optional().describe('Optional lender verification config'),
    fundingSubmissionComponentsArtifactSlug: zod_1.z
        .string()
        .optional()
        .describe('Optional slug for funding submission components artifact'),
})
    .describe('DB node configuration');
// Zod schema and new node type
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    creditFacilitySlug: zod_1.z.string(),
    loanProductSlug: zod_1.z.null(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map